// extracted by mini-css-extract-plugin
module.exports = {"root":"FormPage_root__1qa-F","content":"FormPage_content__1gu8K","title":"FormPage_title__18dxN","description":"FormPage_description__3S6tp"};